import {Accordion, styled} from '@mui/material';

export const StyledAccordion = styled(Accordion)`
	border: none;
	box-shadow: none;
	border-radius: 8px;
	margin: 0;
	padding: 16px;

	&::before {
		display: none;
	}

	.MuiAccordionSummary-root {
		min-height: auto;
		gap: 8px;
		padding: 0;

		${({theme}) => theme.breakpoints.down('md')} {
			align-items: end;
		}
	}

	.MuiAccordionSummary-root > div.MuiAccordionSummary-content {
		margin: 0;
		justify-content: space-between;

		${({theme}) => theme.breakpoints.down('md')} {
			flex-direction: column;
			gap: 12px;
		}

		h6 {
			line-height: initial;
		}
	}
`;
